import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Stream from 'flarum/common/utils/Stream';
import classList from 'flarum/common/utils/classList';
import sortWidgets from '../../common/utils/sortWidgets';
export default class TopWidgetSection extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "scrollEnd", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.scrollEnd = Stream(false);
  }
  view() {
    if (app.current.data.routeName !== 'index') return null;
    if (!app.widgets.get('top').length) return null;
    const isSmallScreen = ['phone', 'tablet'].includes(app.screen());
    return m("div", {
      className: "container"
    }, m("div", {
      className: classList({
        'FofWidgets-topWidgetSection FofWidgets-WidgetSection': true,
        'FofWidgets-WidgetSection--endScroll': isSmallScreen && this.scrollEnd()
      }),
      onscroll: e => {
        if (isSmallScreen) {
          this.scrollEnd(false);
          const target = e.target;
          if (target.offsetWidth + target.scrollLeft >= target.scrollWidth) {
            this.scrollEnd(true);
          }
        }
      }
    }, sortWidgets(app.widgets.get('top')).map(widget => widget.component.component({
      state: widget.state
    }))));
  }
}
flarum.reg.add('fof-forum-widgets-core', 'forum/components/TopWidgetSection', TopWidgetSection);